import React from 'react';
import {
    Text,
    Div,
    ItemNotAvailableDiv,
    MessageContainer,
    ItemTitle,
    Description,
    ButtonFooter,
    ItemsSubText,
    ExclusionItemsNotAllowedDiv,
    ItemsNotAllowedText,
    ProductsContainer,
} from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { hideScrolling, resumeScrolling } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

// common popup used to show notification for item not allowed and item not allowed as extra item
const ItemNotAvailable = ({
    onClose,
    headings,
    isProductFamily,
    excludedItems,
    showCancel = false,
    onCancel = () => { },
    templatePopupHeight,
    color,
    fontFamily,
}) => {
    const { t } = useTranslation();
    const { title, heading1, heading2, heading3, button } = headings || {};
    return (
        <>
            <Popup
                title={title}
                onClose={onClose}
                addProductSpecific={true}
                margin={showCancel}
                mobileZIndex={1000000}
                impersonationBackground={'rgb(47, 45, 70, 0.53)'}
                id={'surgery-notification-itemNotAvailable-popupp'}
            >
                <ItemNotAvailableDiv
                    mbHeight={'auto'}
                    height={
                        title ? (excludedItems ? 'auto' : templatePopupHeight ? templatePopupHeight : '205px') : '145px'
                    }
                >
                    {showCancel ? (
                        <ExclusionItemsNotAllowedDiv
                            mbHeight={'150px'}
                            height={'132px'}
                            width={'100%'}
                            hideScroll={true}
                        >
                            {heading1 ? (
                                <ItemsNotAllowedText margin={'0px'}>
                                    {heading1}
                                </ItemsNotAllowedText>
                            ) : null}
                            {heading2 ? (
                                <ItemsSubText
                                    height={'40px'}
                                    webHeight={'unset'}
                                >
                                    {heading2}
                                </ItemsSubText>
                            ) : null}
                            {excludedItems?.length ? (
                                <ProductsContainer
                                    maxHeight={'82px'}
                                    onPointerMove={resumeScrolling}
                                    onTouchMove={resumeScrolling}
                                    onTouchEnd={hideScrolling}
                                    scrollBarWidth={'5px'}
                                    scrollBarBackgroundColor={'#888'}
                                    scrollBarBorderRadius={'10px'}
                                    scrollbarHeight={'2rem'}
                                    scrollBarBackGroundColorOnHover={'#555'}
                                    mobileDeviceScrollBarDisplay={'block'}
                                    mediumDeviceScrollBarDisplay={'block'}
                                >
                                    {excludedItems.map((product, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                            }}
                                        >
                                            <ItemTitle key={index}>
                                                {product.productCFN}
                                            </ItemTitle>
                                            <Description flexBasis={'60%'}>
                                                {product?.description?.length
                                                    ? product.description[0] +
                                                    product.description
                                                        .slice(1)
                                                        .toLowerCase()
                                                    : ''}
                                            </Description>
                                        </div>
                                    ))}
                                </ProductsContainer>
                            ) : null}
                        </ExclusionItemsNotAllowedDiv>
                    ) : (
                        <>
                            {' '}
                            <MessageContainer>
                                {heading1 ? (
                                    <Text
                                        webHeight={'auto'}
                                        height={'auto'}
                                        font={'17px Avenir Next World'}
                                    >
                                        {' '}
                                        {heading1}
                                    </Text>
                                ) : null}
                                {heading2 ? (
                                    <Text
                                        webHeight={'auto'}
                                        height={'auto'}
                                        font={'17px Avenir Next World'}
                                        color={color}
                                        fontFamily={fontFamily}
                                    >
                                        {' '}
                                        {heading2}
                                    </Text>
                                ) : null}
                                {heading3 ? (
                                    <Text
                                        webHeight={'auto'}
                                        height={'auto'}
                                        font={'17px Avenir Next World'}
                                    >
                                        {' '}
                                        {heading3}
                                    </Text>
                                ) : null}
                            </MessageContainer>
                        </>
                    )}
                    {!showCancel ? (
                        <>
                            <Div
                                marginTop={'15px'}
                                justifyContent={
                                    showCancel
                                        ? 'center'
                                        : isProductFamily
                                            ? false
                                            : 'center'
                                }
                            >
                                <Button
                                 id={'surgery-notifications-itemsnotavailable-okuppercase'}
                                    show={true}
                                    width={'110px'}
                                    height={'38px'}
                                    variant={ButtonStyles?.primary}
                                    //primary={true} 
                                    margin={'5px'}
                                    fontSize={'14.5px'}
                                    clicked={onClose}
                                >
                                    {title && !button
                                        ? t('common.okUpperCaseButton')
                                        : t('common.continueLowerCaseButton')}
                                </Button>
                            </Div>
                            {excludedItems?.length ? (
                                <div
                                    style={{
                                        maxHeight: '80px',
                                        overflow: 'scroll',
                                    }}
                                >
                                    {excludedItems.map((product, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                            }}
                                        >
                                            <ItemTitle key={index}>
                                                {product.productCFN}
                                            </ItemTitle>
                                            <Description>
                                                {product.description}
                                            </Description>
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </>
                    ) : null}

                    {showCancel ? (
                        <ButtonFooter showCancelButton={true}>
                            <Button
                             id={'surgery-notifications-itemsnotavailable-okbutton'}
                            variant={ButtonStyles?.popUpSecondary}
                               // popUpSecondary={true}
                                show={true}
                                width={'150px'}
                                height={'36px'}
                                margin={'13px 3px 0px 0px'}
                                fontSize={'13px'}
                                clicked={onCancel}
                            >
                                {t('common.cancelButton')}
                            </Button>

                            <Button
                                id={'surgery-notifications-itemsnotavailable-ok'}
                                variant={ButtonStyles?.primary}
                                show={true}
                                width={'150px'}
                                height={'36px'}
                                // primary={true}
                                margin={'13px 5px 0px 2px'}
                                fontSize={'13px'}
                                clicked={onClose}
                            >
                                {t('common.okButton')}
                            </Button>
                        </ButtonFooter>
                    ) : null}
                </ItemNotAvailableDiv>
            </Popup>
        </>
    );
};

export default ItemNotAvailable;
